// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BreadCrumbs_wrapper__YXkxU","link":"BreadCrumbs_link__nO1Vc"};